import { useState, useCallback } from 'react';
import congresoService from '../services/congresoService';
import { EntradaAfiliadoDto, ReservarEntradaRequest, ReservarEntradaResponse } from '../types';

export const useAutogestionEntradas = () => {
  const [entradas, setEntradas] = useState<EntradaAfiliadoDto[]>([]);
  const [cargando, setCargando] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [reservaActiva, setReservaActiva] = useState<ReservarEntradaResponse | null>(null);

  const cargarEntradas = useCallback(async (idAfiliado: number) => {
    setCargando(true);
    setError(null);
    try {
      const data = await congresoService.getMisEntradas(idAfiliado);
      setEntradas(data);
    } catch (err: any) {
      setError(err.mensaje || 'Error al cargar tus entradas.');
    } finally {
      setCargando(false);
    }
  }, []);

  const reservarEntrada = async (request: ReservarEntradaRequest) => {
    setCargando(true);
    setError(null);
    try {
      const response = await congresoService.reservarEntrada(request);
      if (response.exitoso) {
        setReservaActiva(response);
      }
      return response;
    } catch (err: any) {
      setError(err.mensaje || 'La reserva de la entrada falló.');
      throw err;
    } finally {
      setCargando(false);
    }
  };

  const nominarEntrada = async (idEntradaDetalle: number, nombre: string, apellido: string, dni: string, email: string) => {
    setCargando(true);
    setError(null);
    try {
      const response = await congresoService.nominarEntrada({
        idEntradaDetalle,
        nombrePortador: nombre,
        apellidoPortador: apellido,
        dniPortador: dni,
        emailPortador: email
      });
      return response;
    } catch (err: any) {
      setError(err.mensaje || 'Error al nominar la entrada.');
      throw err;
    } finally {
      setCargando(false);
    }
  };

  const reasignarEntrada = async (idEntradaDetalle: number, nombre: string, apellido: string, dni: string, email: string) => {
    setCargando(true);
    setError(null);
    try {
      const response = await congresoService.reasignarEntrada({
        idEntradaDetalle,
        nuevoNombrePortador: nombre,
        nuevoApellidoPortador: apellido,
        nuevoDniPortador: dni,
        nuevoEmailPortador: email
      });
      return response;
    } catch (err: any) {
      setError(err.mensaje || 'Error al reasignar la entrada.');
      throw err;
    } finally {
      setCargando(false);
    }
  };

  const descargarCertificado = async (idEntradaDetalle: number) => {
    setError(null);
    try {
      const response = await congresoService.getCertificado(idEntradaDetalle);
      return response;
    } catch (err: any) {
      setError(err.mensaje || 'Error al descargar el certificado.');
      throw err;
    }
  };

  const limpiarReserva = () => {
    setReservaActiva(null);
  };

  return {
    entradas,
    cargando,
    error,
    reservaActiva,
    cargarEntradas,
    reservarEntrada,
    nominarEntrada,
    reasignarEntrada,
    descargarCertificado,
    limpiarReserva
  };
};
